import { queryOptions } from '@tanstack/react-query';
import { api } from '../api-client';
import type { AuthOrganisation } from '../auth-store';
import type { ListResponse, Organisation, OrganisationOverview } from './types';

export const organisationKeys = {
  all: ['organisations'] as const,
  list: () => [...organisationKeys.all, 'list'] as const,
  detail: (orgId: string) => [...organisationKeys.all, 'detail', orgId] as const,
  overview: (orgId: string) => [...organisationKeys.all, 'overview', orgId] as const,
};

export const organisationsApi = {
  list: () => api.get<ListResponse<AuthOrganisation>>('/organisations'),
  create: (input: { name: string }) => api.post<Organisation>('/organisations', input),
  detail: (orgId: string) => api.get<Organisation>(`/organisations/${orgId}`),
  update: (
    orgId: string,
    input: Partial<Pick<Organisation, 'name' | 'billingEmail' | 'defaultLocale' | 'onboardingStep'>>,
  ) => api.patch<Organisation>(`/organisations/${orgId}`, input),
  remove: (orgId: string) => api.delete<{ ok: true }>(`/organisations/${orgId}`),
  overview: (orgId: string) => api.get<OrganisationOverview>(`/organisations/${orgId}/overview`),
};

export const organisationDetailQuery = (orgId: string) =>
  queryOptions({
    queryKey: organisationKeys.detail(orgId),
    queryFn: () => organisationsApi.detail(orgId),
  });

export const organisationOverviewQuery = (orgId: string) =>
  queryOptions({
    queryKey: organisationKeys.overview(orgId),
    queryFn: () => organisationsApi.overview(orgId),
  });
